// Uses the raw scout marker when available, falling back to the coding UI's
// explicit flag for events that do not carry a DataVolley code string.
export function isHomeTeamEvent(event) {
  if (event?.dvString !== undefined) return event.dvString.substring(0, 1) === "*";
  return event?.homePlayer === true;
}
